<template>
  <v-container fluid>
      <v-card>
        <v-toolbar dense flat >
          <v-btn v-show="mode === 'page'" @click="$router.go(-1)" icon light>
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-toolbar-title>{{human.nameShort}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-scroll v-show="human && human.id" md flat :offset="calcOffset(0, 0)">
          <v-layout row wrap >
            <v-flex>
            <v-card>
              <v-card-text>
                <div><b>{{human.nameFull}}</b></div>
                <div>ИНН <b><span v-html="renderInnflHtml(human.inn)"></span></b></div>
                <component v-show="human && human.id" :is="createComp(formatHumanCountersHtml(human.counters))"/>
              </v-card-text>
            </v-card>
            </v-flex>    
            <v-flex>
            <v-card>
              <v-panel-title @click="showExactCompanies=!showExactCompanies" :value="showExactCompanies" >
                  Отчет о найденных компаниях при совпадении ИНН 
                  физического лица
              </v-panel-title>
              <v-card-text v-show="showExactCompanies" class="pt-0">
                <v-flex v-if="displayCompaniesExact.length===0">
                Данные не найдены.
                </v-flex>
                <template v-for="item in displayCompaniesExact">
                  <div>
                    <span v-html="renderReference(item)"></span>
                    <v-icon v-show="isExistActualItem(item.heads)" small>{{getIconName('head')}}</v-icon>
                    <v-icon v-show="isExistActualItem(item.holders)" small>{{getIconName('holder')}}</v-icon>
                    <v-component :is="renderCompanyFlags(item)" />
                    <v-flex pl-2>
                      <div>ОГРН <b v-html="item.id"></b> ИНН <b><span v-html="renderInnHtml(item.inn)"></span></b> - 
                      <span v-html="renderStatus(item.status)"></span></div>
                      <span v-html="renderFirstActivityHtml(item.activities)"></span>
                      <template v-for="head in item.heads">
                        <div>
                          <b :style="head.deleted ? 'text-decoration: line-through;' : ''">{{head.position ? head.position : ''}}</b>
                          <span v-html="renderDateSince(head)"></span>
                          <div v-html="formatDisqualificationHtml(head.disqualification)">
                          </div>
                        </div>
                      </template>
                      <template v-for="holder in item.holders">
                        <div>
                          <b :style="holder.deleted ? 'text-decoration: line-through;' : ''">Участие {{formatPercent(holder)}} {{formatShare(holder)}}</b>
                          <span v-html="renderDateSince(holder)"></span>
                        </div>
                    </template>
                    </v-flex>
                  </div>
                </template>
              </v-card-text>
            </v-card>  
            </v-flex>
            <v-flex>
            <v-card>
              <v-panel-title @click="showLoners=!showLoners" :value="showLoners" >
                  Отчет о ИП при совпадении ИНН 
                  физического лица
              </v-panel-title>
              <v-card-text v-show="showLoners" class="pt-0">
                <v-flex v-if="!loners || loners.length===0">
                Данные не найдены.
                </v-flex>
                <template v-for="item in loners">
                  <span v-html="renderReference(item)"></span>
                  <v-icon small>{{getIconName('loner')}}</v-icon>
                  <v-component :is="renderCompanyFlags(item)" />
                  <div v-html="renderDateSince(item)"></div>                    
                  <v-flex pl-2>                    
                    <div>ОГРНИП <b v-html="item.id"></b> ИНН <b><span v-html="renderInnflHtml(item.inn)"></span></b> - 
                    <span v-html="renderStatus(item.status)"></span></div>
                    <span v-html="renderFirstActivityHtml(item.activities)"></span>
                  </v-flex>
                </template>
              </v-card-text>
            </v-card>  
            </v-flex>            
            <v-flex>
            <v-card>
              <v-panel-title @click="showNotExactCompanies=!showNotExactCompanies" :value="showNotExactCompanies" >
                  Отчет о найденных компаниях при совпадении: ФИО (без совпадений по ИНН)
              </v-panel-title>
              <v-card-text v-show="showNotExactCompanies" class="pt-0">
                <v-flex v-if="displayCompaniesNotExact.length===0">
                Данные не найдены.
                </v-flex>
                <v-flex v-else>
                <b>ВАЖНО!</b> В этот отчет могли попасть иные лица с тождественными ФИО.
                </v-flex>
                <template v-for="item in displayCompaniesNotExact">
                  <div>
                    <div>
                      <span v-html="renderReference(item)"></span>
                      <v-icon v-show="isExistActualItem(item.heads)" small>{{getIconName('head')}}</v-icon>
                      <v-icon v-show="isExistActualItem(item.holders)" small>{{getIconName('holder')}}</v-icon>
                      <v-component :is="renderCompanyFlags(item)" />
                    </div>
                    <v-flex pl-2>
                      <div>ОГРН <b v-html="item.id"></b> ИНН <b><span v-html="renderInnHtml(item.inn)"></span></b> - 
                      <span v-html="renderStatus(item.status)"></span></div>
                      <span v-html="renderFirstActivityHtml(item.activities)"></span>
                      <template v-for="head in item.heads">
                          <div>
                            <b :style="head.deleted ? 'text-decoration: line-through;' : ''">{{head.position ? head.position : ''}}</b>
                            <span v-html="renderDateSince(head)"></span>
                            <div v-html="formatDisqualificationHtml(head.disqualification)">
                            </div>
                          </div>
                        </template>
                        <template v-for="holder in item.holders">
                          <div>
                            <b :style="holder.deleted ? 'text-decoration: line-through;' : ''">Участие {{formatPercent(holder)}} {{formatShare(holder)}}</b>
                            <span v-html="renderDateSince(holder)"></span>
                          </div>
                      </template>
                    </v-flex>
                  </div>
                </template>
              </v-card-text>
            </v-card>  
            </v-flex>
          </v-layout>
        </v-card-scroll>
      </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import vPanelTitle from './PanelTitle'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'human-page',
    components: {vPanelTitle, vCardScroll},
    data: () => ({
      human: null,
      showExactCompanies: true,
      showNotExactCompanies: false,
      showLoners: true
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      }
    },
    created () {
      this.initHuman()
    },
    mounted () {
      if (this.itemId) {
        this.fetchHumanProps(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.fetchHumanProps(newVal)
        } else {

        }
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderInnHtml: 'renderInnHtml',
        renderInnflHtml: 'renderInnflHtml',
        renderDateSince: 'renderDateSince',
        renderStatus: 'renderStatus',
        renderFlags: 'renderFlags',
        renderFirstActivityHtml: 'renderFirstActivityHtml',
        getIconName: 'getIconName',
        renderShare: 'renderShare',
        calcDialogOfs: 'calcDialogOfs',
        calcOfs: 'calcOfs'
      }),
      displayCompaniesExact () {
        return this.mergeHeadsAndHolders(this.displayHeadsExact, this.displayHoldersExact)
          .sort((a, b) => this.sortCompanies(a, b))
      },
      displayCompaniesNotExact () {
        return this.mergeHeadsAndHolders(this.displayHeadsNotExact, this.displayHoldersNotExact)
          .sort((a, b) => this.sortCompanies(a, b))
      },
      displayHeadsExact () {
        if (!this.human || !this.human.heads) {
          return []
        }
        return this.human.heads.filter(h => h.exact)
      },
      displayHoldersExact () {
        if (!this.human || !this.human.holders) {
          return []
        }
        return this.human.holders.filter(h => h.exact)
      },
      displayHeadsNotExact () {
        if (!this.human || !this.human.heads) {
          return []
        }
        return this.human.heads.filter(h => !h.exact)
      },
      displayHoldersNotExact () {
        if (!this.human || !this.human.holders) {
          return []
        }
        return this.human.holders.filter(h => !h.exact)
      },
      loners () {
        return this.human && this.human.loners && this.human.loners.map(l => Object.assign(l, {created: l.createDate, updated: l.releaseDate}))
      }
    },
    methods: {
      calcOffset (off, offModal) {
        return this.calcOfs(off, offModal)
      },
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + ' руб.' : ''
      },
      formatShare (holder) {
        var share = formats.getValue(holder, ['shares', 0, 'share'])
        return share !== null ? '(' + this.formatCurrency(share) + ')' : ''
      },
      formatPercent (holder) {
        var share = formats.getValue(holder, ['shares', 0])
        return this.renderShare(share)
      },
      formatHumanCountersHtml (counters) {
        const _f = v => v !== null ? v : 'нет данных'
        if (!counters) {
          return '<div></div>'
        }
        var result = ''.concat(
          `<div>`,
          `<div>`,
          `Руководитель компаний (совпадение по ИНН / ФИО*): `,
          `<b><v-icon small>${this.getIconName('head')}</v-icon> ${_f(counters.managedCompaniesExact)} / ${_f(counters.managedCompaniesGeneral)}</b>`,
          `</div>`,
          `<div>`,
          `Учредитель или участник (совпадение по ИНН /  ФИО*): `,
          `<b><v-icon small>${this.getIconName('holder')}</v-icon> ${_f(counters.sharedCompaniesExact)} / ${_f(counters.sharedCompaniesGeneral)}</b>`,
          `</div>`,
          `<div>`,
          `Индивидуальный предприниматель: `,
          `<b><v-icon small>${this.getIconName('loner')}</v-icon> ${_f(counters.loners)}</b>`,
          `</div>`,
          `<div>`,
          `Проведена проверка в реестре дискваливицированных лиц, найдено дисквалификаций (совпадение по ИНН / ФИО*): `,
          `<b> ${_f(counters.disqualificationsExact)} / ${_f(counters.disqualificationsGeneral)}</b>`,
          `</div>`,
          `<div>`,
          `* Примечание: в отчет о поиске физического лица по ФИО могли попасть иные лица с тождественными ФИО. `,
          `</div>`,
          `</div>`
          )
        return result
      },
      isExistActualItem (items) {
        return items && items.length > 0 && items[0].created && items[0].deleted === null
      },
      formatDisqualificationHtml (disq) {
        if (!disq) {
          return ''
        }
        return formats.formatErrorHtml(`Дисквалифицирован с ${formats.formatDate(disq.fromDate)} по ${formats.formatDate(disq.toDate)} решением от ${formats.formatDate(disq.decisionDate)}`)
      },
      mergeHeadsAndHolders (heads, holders) {
        var st = new Set()
        var result = heads.map(hd => {
          var hl = holders.find(i => i.ogrn === hd.ogrn)
          if (hl) {
            hd.holders = hl.holders
            st.add(hd.ogrn)
          }
          return hd
        })
        result = result.concat(holders.filter(i => !st.has(i.ogrn)))
        return result
      },
      sortCompanies (a, b) {
        const getRank = (kind) => ['GOOD', 'WARN', 'BAD', 'OLD'].indexOf(kind)
        const getFirst = (items) => items && items.length > 0 && items[0] || null

        var result = 0
        if (!result) {
          result = getRank(a.status.kind) - getRank(b.status.kind)
        }
        let ahead = getFirst(a.heads)
        let bhead = getFirst(b.heads)
        if (!result && !(bhead && ahead)) {
          result = (bhead != null) - (ahead != null)
        }
        if (!result && (bhead && ahead) && !(!bhead.deleted && !ahead.deleted)) {
          result = (ahead.deleted != null) - (bhead.deleted != null)
        }
        let aholder = getFirst(a.holders)
        let bholder = getFirst(b.holders)
        if (!result && !(bholder && aholder)) {
          result = (bholder != null) - (aholder != null)
        }
        if (!result && (bholder && aholder) && !(!bholder.deleted && !aholder.deleted)) {
          result = (aholder.deleted != null) - (bholder.deleted != null)
        }
        if (!result && (bholder && aholder)) {
          var valB = formats.getValue(bholder, ['shares', 0, 'part', 'numerator']) / formats.getValue(bholder, ['shares', 0, 'part', 'denominator'])
          var valA = formats.getValue(aholder, ['shares', 0, 'part', 'numerator']) / formats.getValue(aholder, ['shares', 0, 'part', 'denominator'])
          result = valB - valA
        }
        if (!result && (bholder && aholder)) {
          result = (formats.getValue(bholder, ['shares', 0, 'share']) - formats.getValue(aholder, ['shares', 0, 'share']))
        }
        return result
      },
      getHumanProps (inn, cb) {
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о компании из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/humans/' + inn,
          cb,
          cbError)
      },
      fetchHumanProps (inn) {
        this.initHuman()
        this.getHumanProps(inn, (data) => {
          this.human = data
        })
      },
      initHuman () {
        this.human = {
          id: null,
          inn: null,
          nameShort: '',
          nameFull: ''
        }
      },
      renderCompanyFlags (item) {
        return item ? this.renderFlags(item.flags, true) : null
      },
      createComp (template) {
        return formats.createComp(template)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// HumanPage.vue?7cfe7f68